import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "block" }

import SvgIcon from "@SharedVueComponents/SvgIcon/SvgIcon.vue";
import { store } from "@/state/store";

export type BenefitItem = {
	iconName: string;
	title: string;
	description: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'BenefitItems',
  props: {
    items: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass(_unref(store).isLandingPage ? 'grid gap-6 lg:grid-cols-[repeat(4,auto)] lg:gap-4' : 'grid gap-3 text-sm')
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
      return (_openBlock(), _createElementBlock("li", {
        key: `item-${i}`,
        class: _normalizeClass(["flex items-center", _unref(store).isLandingPage ? 'py-1.5' : ''])
      }, [
        (item.iconName)
          ? (_openBlock(), _createBlock(SvgIcon, {
              key: 0,
              "icon-name": item.iconName,
              class: "mr-2 block size-10 shrink-0"
            }, null, 8, ["icon-name"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["text-sm", { 'lg:text-xs': _unref(store).isLandingPage }])
        }, [
          _createElementVNode("b", {
            class: _normalizeClass(["block font-semibold", _unref(store).isLandingPage ? 'pb-1' : ''])
          }, _toDisplayString(item.title), 3),
          _createElementVNode("span", _hoisted_1, _toDisplayString(item.description), 1)
        ], 2)
      ], 2))
    }), 128))
  ], 2))
}
}

})